import { SettingsService } from '../../../services/settings-service';
import PrimaryPrivacyViewController from '../privacy-views/primary-privacy-view/primary-privacy-view-controller';
import SecondaryBasicPrivacyViewController from '../privacy-views/secondary-basic-privacy-view/secondary-basic-privacy-view-controller';
import SecondaryAdvancePrivacyViewController from '../privacy-views/secondary-advance-privacy-view/secondary-advance-privacy-view-controller';
import { ConsentsStatusService } from '../../../services/consents-services/consents-status.service';
import { DataService } from '../../../services/utilities/data.service';
import DataExchangeService from '../../../services/data-exchange.service';

const _ = require('lodash');
const modalElementId = 'uc-center-modal';

export default class PrivacyCenterModalViewController {
    private initialModalView: string = '';
    public isCenterModal:boolean = true;
    private mainViewContoller: any;
    private primaryPrivacyViewController: PrimaryPrivacyViewController;
    private secondaryBasicPrivacyViewController: SecondaryBasicPrivacyViewController;
    private secondaryAdvancePrivacyViewController: SecondaryAdvancePrivacyViewController;
    private settingsService: SettingsService;
    private state: any;
    private updateView: any;

    constructor(mainViewContoller, updateView, bannerController, utilityService) {
        this.mainViewContoller = mainViewContoller;
        this.updateView = updateView;
        this.settingsService = utilityService.settingsService;
        const layoutParams = this.getPreparedLayoutParams();

        this.initialModalView = layoutParams.initialModalView;
        this.setInitialState();

        this.primaryPrivacyViewController = new PrimaryPrivacyViewController(this, layoutParams, utilityService);
        this.secondaryBasicPrivacyViewController = new SecondaryBasicPrivacyViewController(
            mainViewContoller,
            this,
            layoutParams,
            utilityService
        );
        this.secondaryAdvancePrivacyViewController = new SecondaryAdvancePrivacyViewController(
            mainViewContoller,
            this,
            layoutParams,
            bannerController,
            utilityService
        );
    }

    private setInitialState() {
        const states = ['primary', 'secondary-basic', 'secondary-advance'];
        _.forEach(states, state => {
            if (~this.initialModalView.indexOf(state)) {
                this.changeState(state, true);
                if (state === states[2]) {
                    if (this.secondaryAdvancePrivacyViewController) {
                        this.secondaryAdvancePrivacyViewController.resetPurposes();
                    }
                }
            }
        });
    }

    private openModal() {
        this.visible = true;
        this.resetAll();
    }

    private closeModal() {
        this.visible = false;
        this.resetAll();

        const dataExchangeService = new DataExchangeService();
        dataExchangeService.dataExchangeArray = this.settingsService.settings.dataExchangeOnPage;
        dataExchangeService.dispatchEvent('uc_privacySettingsCenterClosed', {event: 'uc_privacySettingsCenterClosed'});

        ConsentsStatusService.resetAllConsents(DataService.consents);
    }

    private resetAll() {
        this.resetViews();
        this.setInitialState();
        this.updateView();
    }

    private resetViews() {
        this.primaryPrivacyViewController.visible = false;
        this.secondaryBasicPrivacyViewController.visible = false;
        this.secondaryAdvancePrivacyViewController.visible = false;
    }

    private getHtml() {
        let viewHTML: any = 'No appropriate template or some error';
        this.resetViews();
        switch (this.state) {
        case 'primary-privacy-view':
            this.primaryPrivacyViewController.visible = true;
            viewHTML = this.primaryPrivacyViewController.htmlString;
            break;
        case 'secondary-basic-privacy-view':
            this.secondaryBasicPrivacyViewController.visible = true;
            viewHTML = this.secondaryBasicPrivacyViewController.htmlString;
            break;
        case 'secondary-advance-privacy-view':
            this.secondaryAdvancePrivacyViewController.visible = true;
            viewHTML = this.secondaryAdvancePrivacyViewController.htmlString;
            break;
        default:
            break;
        }

        return viewHTML;
    }

    private getPreparedLayoutParams() {
        const layouts = SettingsService.layouts;
        const goalLayout = _.find(layouts, {
            name: this.settingsService.settings.layout
        });

        return {
            modalView: goalLayout.centerModalView,
            initialModalView: goalLayout.initialCenterModalView
        };
    }

    public getModalWrapperElement() {
        return document.getElementById(modalElementId);
    }

    public changeState(_state, initial = false) {
        this.state = _state + '-privacy-view';
        !initial && this.updateView();
    }

    public initHandling() {
        if (this.visible) {
            this.primaryPrivacyViewController.initHandling();
            this.secondaryBasicPrivacyViewController.initHandling();
            this.secondaryAdvancePrivacyViewController.initHandling();
        }
    }

    updateCloseIconVisibility(stat) {
        this.settingsService.elementsVisibility.closeIconCenterModal = stat;
    }

    public set visible(_isVisible: boolean) {
        this.settingsService.centerModelIsVisible = _isVisible;
    }

    public get visible() {
        return this.settingsService.elementsVisibility.centerModel;
    }

    public get htmlString(): string {
        if (this.visible) {
            return this.getHtml();
        }
        return '';
    }
}
